import {AUTH_AXIOS} from "@/modules/auth/api/backend-config";

export default {
    getEnvironment() {
        return AUTH_AXIOS.get('/application-info/environment');
    }
}